import BaseModel from "nexia_mobile/models/base_model";

export default class Alert extends BaseModel {
  parseLinksClear(links) {
    let link = _.first(links);
    this._clearHref = link ? link.getHref() : this._clearHref;
  }

  clear() {
    let model = new BaseModel();
    model.setAsEphemeral();
    model.setUrl(this._clearHref);
    return model.save(
      {},
      {
        method: "POST",
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/models/alert.js